import loading from './loading.vue';

export default {
    install(Vue) {
        const Constructor = Vue.extend(loading);
        const instance = new Constructor();
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);

        Vue.prototype.$showLoading = ({ title = '加载中', mask = false }) => {
            instance.message = title;
            instance.show = true;
        };

        Vue.prototype.$hideLoading = () => {
            instance.show = false;
        };
    },
};
